import Image from "@/components/AppImage";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";
import Link from "@/components/AppLink";
import check_alt from "/public/img/check-alt.png";

const CallAction = () => {
  return (
    <section className="call-action-inner">
      <div className="overlay pt-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-8 d-flex align-items-center">
              <div className="section-header text-center">
                <h3>Route client payments home—without surprise fees</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="bottom-area">
                <div className="row justify-content-center">
                  <div className="col-lg-6">
                    <div className="d-flex flex-wrap justify-content-between gap-4">
                      <ul className="d-flex flex-column">
                        <li>
                          <div className="icon">
                            <Image src={check_alt} alt="icon" />
                          </div>
                          Licensed & Regulated
                        </li>
                        <li>
                          <div className="icon">
                            <Image src={check_alt} alt="icon" />
                          </div>
                          100% Transparent
                        </li>
                      </ul>
                      <ul className="d-flex flex-column justify-content-end">
                        <li>
                          <div className="icon">
                            <Image src={check_alt} alt="icon" />
                          </div>
                          Hassle-free
                        </li>
                        <li>
                          <div className="icon">
                            <Image src={check_alt} alt="icon" />
                          </div>
                          Across 180+ Countries
                        </li>
                      </ul>
                    </div>
                    <div className="btn-area text-center">
                      <Link href={getDashboardPathUrl("/register")} className="cmn-btn">
                        Get started
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallAction;
